export default __webpack_public_path__ + "static/media/shape.d6ce84fb.svg";